import AdminConfig from './AdminConfig.vue';

import ClientView from './clientView.vue';


export default {
  name : 'map',

  type : 'module',
  
  label: 'Carte interactive',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-map',
  }
}